/**
 * Markers the article renderer strips out of a Lexical text run before painting
 * it, so a run that is *only* an inline image (or whose visible text differs
 * from the raw `node.text` once stripped) renders no visible text. Shared with
 * the renderer (`renderLexicalNode` in `article-detail-client.tsx`) so it strips
 * the same markers everywhere.
 */
export const IMAGE_PLACEHOLDER_RE = /\[IMAGE:[^\]]*\]/g
export const RAW_IMG_TAG_RE = /<img\b[^>]*>/gi
